import { Component, inject, OnInit } from '@angular/core'
import { Observable } from 'rxjs'

import { Environment } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService, SnackbarService } from '@hyperkit'

import { getToolIcon } from '../../../../helpers/utils'
import { EnvironmentService } from '../../../shared/services/environment.service'

import { DeleteEnvironmentDialogComponent } from './delete-environment-dialog/delete-environment-dialog.component'
import { EditEnvironmentDialogComponent } from './edit-environment-dialog/edit-environment-dialog.component'
import { NewEnvironmentDialogComponent } from './new-environment-dialog/new-environment-dialog.component'

@Component({
  standalone: false,
  templateUrl: './environment.component.html',
  styleUrls: ['./environment.component.scss'],
})
export class EnvironmentComponent implements OnInit {
  dialogService = inject(DialogService)
  environmentService = inject(EnvironmentService)

  public environments$: Observable<Environment[]>
  public getToolIcon = getToolIcon
  public readonly snack = inject(SnackbarService)

  public ngOnInit(): void {
    this.environments$ = this.environmentService.getAllEnvironments()
  }

  public editEnvironment(environment: Environment): void {
    const dialogRef: DialogRef = this.dialogService.open(
      EditEnvironmentDialogComponent,
      { data: environment },
    )

    dialogRef.afterClosed().subscribe((updatedHunt: Environment) => {
      if (updatedHunt)
        this.environments$ = this.environmentService.getAllEnvironments()
    })
  }

  public deleteEnvironment(environment: Environment): void {
    const dialogRef: DialogRef = this.dialogService.open(
      DeleteEnvironmentDialogComponent,
      { data: environment },
    )

    dialogRef.afterClosed().subscribe((deletedEnvironment: Environment) => {
      if (deletedEnvironment) {
        this.snack.show(
          `Deleted environment - ${deletedEnvironment.name}`,
          5000,
        )
        this.environments$ = this.environmentService.getAllEnvironments()
      }
    })
  }

  public newEnvironment(): void {
    const dialogRef: DialogRef = this.dialogService.open(
      NewEnvironmentDialogComponent,
    )

    dialogRef.afterClosed().subscribe((updatedHunt: Environment) => {
      if (updatedHunt)
        this.environments$ = this.environmentService.getAllEnvironments()
    })
  }
}
